/**
 * Player / zapper timing and threshold constants (live + VOD hooks).
 */

/** Time in ms the pilot hint is displayed (live). */
export const HINT_DISPLAY_TIME = 5 * 1000;

/** Minimum offset from live edge in seconds (timeshift detection). */
export const MINIMUM_LIVE_OFFSET = 60;

/** Time in ms the pilot stays visible before auto-hide (live + VOD). */
export const PILOT_DISPLAY_TIME = 60 * 1000;
